import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	Input,
	OnChanges,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { SelectCommoditiesService } from '../../service/select-commodities.service';
import { MatSelect } from '@angular/material/select';
import { Utilities } from '../../utilities/utilities.model';
import { CommodityModel } from '@shared/models/commodity.model';
import { PermissionService } from '@shared/service/permission.service';
import { UserV3Model } from '@shared/models/user-v-3.model';
import { Location } from '@angular/common';
import { ROOT_AUTHORITY } from '../../../app-routing-roots';
import { CommoditiesUtilityService } from '@shared/service/commodities-utility.service';
import { TranslateContext, TranslatePipe } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-select-center',
	templateUrl: './select-center.component.html',
	styleUrls: ['./select-center.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class SelectCenterComponent implements OnChanges, AfterViewInit {

	@ViewChild('select') select: MatSelect;
	// @ViewChild('allCommoditiesNameValue') allCommoditiesNameValue: ElementRef;
	@Input() itemMenuID: string;
	@Input() commodities: CommodityModel[];
	@Input() isFilterCommoditiesByParent: boolean;
	commodity: CommodityModel;
	defaultPlaceholder: string;
	sameName: boolean = false;
	isTyresModule: boolean;
	isAuthority: boolean;
	commoditiesToShow: CommodityModel[] = [];
	hasSingleCommodity: boolean = false;
	lenght: number;
	t = TranslateContext;
	allCentersCommodity: number = CommodityModel.allCentersID;
	// labelFirstCommodity: string = 'TUTTI_I_CENTRI';
	fakeCommodity: CommodityModel = new CommodityModel({ald_commodity_id: CommodityModel.allCentersID});

	constructor(
		public selectCommoditiesService: SelectCommoditiesService,
		public permissionService: PermissionService,
		private location: Location,
		private cd: ChangeDetectorRef,
		private commoditiesUtilityService: CommoditiesUtilityService,
		private translatePipe: TranslatePipe,
	) {
		this.selectCommoditiesService.commoditiesObservable.subscribe((commodities: CommodityModel[]) => {
			this.cd.detectChanges();
		});
	}

	ngOnChanges(changes: SimpleChanges): void { // Normal but debugging mode
		if (!Utilities.isVoid(changes) && !Utilities.isVoid(changes.itemMenuID)) {
			this.itemMenuID = changes.itemMenuID.currentValue;
			this.isAuthority = this.location.path().includes(`/${ROOT_AUTHORITY}/`);
			this.isTyresModule =
				this.itemMenuID === UserV3Model.TYRES_ITEM_OPC_MENU_ID ||
				this.itemMenuID === UserV3Model.TYRES_ITEM_OPA_MENU_ID ||
				this.itemMenuID === UserV3Model.TYRES_ITEM_OPF_MENU_ID ||
				this.itemMenuID === UserV3Model.TYRES_ITEM_OPS_MENU_ID;
		}
		if ((changes.commodities && changes.commodities.currentValue)) {
			this.commodities = changes.commodities.currentValue;
			if (this.commodities.length > 0) {
				this.selectCommoditiesService.setAll(this.commodities);
			}
		}
		// todo da migliorare perchè attualmente passa nel lifecycle all'infinito
		if ((changes.commodities && changes.commodities.currentValue && !Utilities.compareArray(changes.commodities.previousValue, changes.commodities.currentValue)) || changes.isFilterCommoditiesByParent) {
			this.commodity = null;
			this.commodities = changes.commodities && changes.commodities.currentValue;
			this.sameName = this.haveSameName();
			// if (
			// 	!Utilities.isVoid(this.commodities) && 
			// 	!Utilities.isVoid(this.commodities[0]) && 
			// 	this.commodities[0].ald_commodity_id === CommodityModel.allCentersID
			// ) {
			// 	this.commodities[0].name = this.translatePipe.transform(this.labelFirstCommodity, this.t.SHARED);
			// 	this.commodities[0].setLabels();
			// }
			if (!this.commodity || this.commodity.ald_commodity_id === CommodityModel.allCentersID) {
				this.onChangeCommodities(null, false);
			} else {
				this.onChangeCommodities({ value: this.commodity }, false);
			}
		}
	}

	haveSameName(): boolean {
		if (this.commodities) {
			let lastName: string = null;
			for (const c of this.commodities) {
				if (c.ald_commodity_id !== CommodityModel.allCentersID) {
					if (!Utilities.isVoid(lastName) && lastName !== c.name) {
						return false;
					}
					lastName = c.name;
				}
			}
			return true;
		}
		return false;
	}

	ngAfterViewInit(): void {
		if (!Utilities.isVoid(this.select) && !Utilities.isVoid(this.select.placeholder)) {
			this.defaultPlaceholder = this.select.placeholder;
			setTimeout(() => this.setPlaceHolder(), 0);
		}
	}

	onChangeCommodities(event: any, submitGetlist: boolean): void {
		this.hasSingleCommodity = false;
		if (this.commodities && this.commodities.length > 0) {

			// let changed: boolean = false;

			// // event è null solo durante il caricamento del component
			// if (event) {

			// 	// qui andrebbe gestita la logica del setCommodities
			// 	// evitando $changed e altre logiche inutili

			// 	if (this.commodity.id !== event.value.id) {
			// 		changed = true;
			// 		this.commodity = event.value;
			// 	}
			// } else {
			// 	changed = true;
			// 	// this.commodity = this.commodities[0];
			// 	// si può fare di meglio
			// 	this.commodity = this.fakeCommodity;
			// }
			// this.updateCurrentCenterLabel();
			// if (changed) {
			// 	// if (this.commodity.ald_commodity_id === CommodityModel.allCentersID) {
			// 	// 	this.selectCommoditiesService.setCommodities(this.commodities);
			// 	// } else {
			// 	// 	this.selectCommoditiesService.setCommodities(this.commodity);
			// 	// }
			// 	// il ternario è tuo amico
			// 	const list = (this.commodity.ald_commodity_id === CommodityModel.allCentersID) ? this.commodities : this.commodity;
			// 	this.selectCommoditiesService.setCommodities(list);
			// }

			// REFACTORING

			// in teoria la commodity in input è sempre diversa da quella corrente
			this.commodity = event ? event.value : this.fakeCommodity;

			this.updateCurrentCenterLabel();
			const list = (this.commodity.ald_commodity_id === CommodityModel.allCentersID) ? this.commodities : this.commodity;
			this.selectCommoditiesService.setCommodities(list, submitGetlist);

		} else {
			this.selectCommoditiesService.setCommodities([], submitGetlist);
		}

		this.commoditiesToShow = this.selectCommoditiesService.getAllClustered();

		if (this.commoditiesToShow.length === 2 && !this.commoditiesToShow[0].id) {
			this.commodity = this.commoditiesToShow[1];
			this.hasSingleCommodity = true;
		} else {
			this.hasSingleCommodity = false;
		}
	}

	onOpen(event: any): void {
		if (!Utilities.isVoid(this.commodities)) {
			this.commodities.forEach(c => c.setLabelForNotSelected());
		}
	}

	onClose(event: any): void {
		this.updateCurrentCenterLabel();
	}

	private updateCurrentCenterLabel(): void {
		setTimeout(() => {
			if (!Utilities.isVoid(this.commodity)) {
				this.commodity.setLabelForSelected();
				this.setPlaceHolder();
			}
		}, 0);
	}

	setPlaceHolder(): void {
		if (!Utilities.isVoid(this.select) && !Utilities.isVoid(this.select.placeholder) && !Utilities.isVoid(this.commodity)) {
			if (this.hasSingleCommodity) {
				this.select.placeholder = null;
			} else {
				if (this.commodity.ald_commodity_id === CommodityModel.allCentersID && this.commodities.length > 1) {
					this.select.placeholder = this.sameName ? this.commodities[1].name : this.defaultPlaceholder;
				} else {
					if (this.isTyresModule) {
						this.select.placeholder = this.commodity.network_name;
					} else {
						this.select.placeholder = this.commodity.name;
					}
				}
			}
		}
	}

	getOptionLabel(commodity: CommodityModel): string {
		return !this.isAuthority ? commodity.labelForSelect : !!commodity.address ? `${commodity.name} - ${commodity.address}, ${commodity.address_number}` : commodity.name;
	}
}
